<template>
  <div v-if="dataWasDownloadedSuccessfully">
    <section class="text-human-ressources container bg-wht">

      <div class="content content-centered content-roomy trimmed-width-3 d-grid column-gap-4 row-gap-3">

        <div class="group-description">
          <h3>{{data.hrTitle}}</h3>
          <p>{{data.hrDescription}}</p>
          <p class="d-grid column-gap-3 row-gap-1 mt-3" v-for="(contact, index) in data.hrContakt" :key="index">
            <strong>{{contact.fields.title}}</strong>
            <a v-if="contact.fields.mailto" :href="'mailto:'+contact.fields.mailto" :title="contact.fields.seoTitle">
              <span >{{contact.fields.mailto}}</span>
            </a>
            <a v-if="contact.fields.telefon" :href="'tel:'+contact.fields.telefon" :title="contact.fields.seoTitle">
              <span >{{contact.fields.telefon}}</span>
            </a>
          </p>
        </div>
        <div class="group-contact d-flex flex-row justify-self-end mt-5 mt-md-0">
          <!-- Start loop -->
          <div class="module--profile text-xs-center mx-3" v-for="(profile,idx) in data.hrProfile" v-bind:key="idx">
            <div class="avatar mb-2" v-on:click="openModal('modal'+idx)">
              <img :src="profile.fields.profileImage.fields.file.url" :id="'open-button'+idx" alt="">
              <i class="icon-expand"></i>
            </div>
            <h6 class="mb-1">{{ profile.fields.profileName }}</h6>
            <p class="font-xs mt-0">{{ profile.fields.profileJobTitle }}</p>
            <div class="social-networks d-flex flex-row flex-justify-center column-gap-3 mt-3">
              <a :href="profile.fields.profileLinkedinLink" title="Profil auf Xing"
                v-if="profile.fields.profileLinkedinLink">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" class="icon-xing zoom-on-hover">
                  <path
                    d="M26.667 25.893l-8-14.533a1.333 1.333 0 00-1.174-.693H4a1.333 1.333 0 00-1.173 1.973l7.6 13.867-10.24 16.8a1.333 1.333 0 001.146 2.026h13.52a1.333 1.333 0 001.147-.64l10.667-17.466a1.333 1.333 0 000-1.334zM63.813.667A1.333 1.333 0 0062.667 0h-14.32A1.333 1.333 0 0047.2.667L25.867 38a1.333 1.333 0 000 1.333l13.706 24A1.333 1.333 0 0040.72 64h14.32a1.333 1.333 0 001.147-2L42.853 38.613 63.813 2a1.333 1.333 0 000-1.333z" />
                </svg>
              </a>
              <a :href="profile.fields.profileXingLink" title="Profil auf LinkedIn"
                v-if="profile.fields.profileLinkedinLink">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" class="icon-linkedin zoom-on-hover">
                  <path
                    d="M5.333 22.667h13.334V60H5.333zM5.333 10.667a6.613 6.667 0 1013.227 0 6.613 6.667 0 10-13.227 0zM49.333 60h8a1.333 1.333 0 001.334-1.333v-22.4c0-10.054-5.68-14.934-13.627-14.934a11.227 11.227 0 00-8.453 3.387 1.093 1.093 0 01-1.92-.72 1.333 1.333 0 00-1.334-1.333h-8A1.333 1.333 0 0024 24v34.667A1.333 1.333 0 0025.333 60h8a1.333 1.333 0 001.334-1.333v-20a6.667 6.667 0 0113.333 0v20A1.333 1.333 0 0049.333 60z" />
                </svg>
              </a>
            </div>

            <div class="modal" :id="'modal'+idx" :ref="'modal'+idx">
              <button class="btn close-button" id="close-button"><i class="icon-close"
                  v-on:click="closeModal('modal'+idx)"></i></button>
              <div class="modal-content">
                <div class="modal--two-columns d-grid">
                  <div class="modal--image">
                    <small class="modal--image-title text-xs-left">
                      <span class="h-4 mb-1">{{ profile.fields.profileName }}</span>
                      <span>{{ profile.fields.profileJobTitle }}</span>
                    </small>
                    <img :src="profile.fields.profileImage.fields.file.url" alt="">
                  </div>
                  <div class="modal--text text-xl-left">
                    <h5>{{ profile.fields.profileSkillsTitle }}</h5>
                    <p>{{ profile.fields.profileSkillsDescription }}</p>
                    <h5>{{ profile.fields.profileVitaTitle }}</h5>
                    <p>{{ profile.fields.profileVitaDescription }}</p>
                    <h5>{{ profile.fields.profileOthersTitle }}</h5>
                    <p>{{ profile.fields.profileOthersDescription }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- End loop -->
        </div>
      </div>
    </section>
  </div>
</template>
<script>
  import { getContent } from '@/javascripts/contentful';

  export default {
    name: 'hrTeamApp',
    props: ['entryId'],
    data() {
      return {
        dataWasDownloadedSuccessfully: false,
        data: null,
      }
    },
    methods: {
      openModal(evt) {
        this.$refs[evt][0].classList.toggle('open')
        this.$refs[evt][0].classList.toggle('closed')
      },
      closeModal(evt) {
        this.$refs[evt][0].classList.toggle('closed')
        this.$refs[evt][0].classList.toggle('open')
      }
    },
    async mounted() {
      const { fields } = await getContent(this.entryId)

      if (fields) {
        this.data = { ...fields }
        this.dataWasDownloadedSuccessfully = true
      }
    },
  }
</script>
